<template>
  <div>
      <div class="panel panel--minimal-pad">
        <div class="panel__header">
          <div class="panel__header__left panel__header-width-m">
            	Balance Description
          </div>
          <div class="panel__header__right">
            <div class="filter__options">
                <select name="disburse-source" id="disburseSource" class="select__input select__input--sm" @change="optionType()" v-model="type">
                  <option value="" disabled>Options</option>
                  <option value="Transfer">Transfer to another Balance</option>
                  <option value="Password">Change wallet password</option>
                  <!-- <option value="Disbale">Disable wallet</option> -->
                </select>
            </div>
            <div class="contact-trigger">
              <router-link
              :to="{name:'single-disburse-id'}"
              class="btn btn--primary btn--flex"
            >+ New Transfer</router-link>
            </div>
          </div>
        </div>
        <!--equalized tables, for want of a better name, sigh-->
        <div class="panel__content panel__content--grey outer-container equalized-tables">
          <!--transfer history table-->

          <!--transfer loading-->
          <div class="loaderContainer" v-if="isLoading">
            <img src="/static/wave.gif" alt="" width="32" height="32">
          </div>

          <div v-if="!isLoading">
            <div class="table__section table__section--head">
              Summary
            </div>
            <div class="card">
              <div class="card__content card__content--flex">
                <table width="100%">
                  <tr>
                    <td width="30%">
                      <span>NAME</span><br>
                      {{ walletDetail.name }}
                    </td>
                    <td width="30%">
                      <span>BALANCE</span><br>
                      {{ walletDetail.currency.shortCode }} {{ walletDetail.balance | numeralize('0,0.00') }}
                    </td>
                    <td width="15%">
                      <span>CURRENCY</span><br>
                      {{ walletDetail.currency.shortCode }}
                    </td>
                    <td width="15%">
                      STATUS<br>
                      <span v-if="walletDetail.enabled" class="tag" :class="['tag--completed']"><b>Active</b></span>
                      <span v-else-if="!walletDetail.enabled" class="tag" :class="['tag--reversed']"><b>Disabled</b></span>
                    </td>
                    <td width="15%">
                      <span>THRESHOLD</span><br>
                      {{ walletDetail.threshold }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <br>

          <div v-if="walletDetail.draw">
            <div class="table__section table__section--head">
              Overdraft <span>Enabled</span>
            </div>

            <div class="card">
              <div class="card__content card__content--flex">
                <table width="100%">
                  <tr>
                    <td width="30%">
                      AMOUNT<br>
                      {{ walletDetail.draw | numeralize('0,0.00') }}
                    </td>
                    <td width="30%">
                      AVAILABLE ON<br>
                      {{ walletDetail.draw_on }}
                    </td>
                    <td width="30%">
                      CHARGE<br>
                      <span v-if="walletDetail.draw_markup">{{ walletDetail.currency.shortCode }} {{ walletDetail.draw_markup }} Markup,</span>
                      <span v-if="walletDetail.draw_charge">{{ walletDetail.draw_charge }} % Daily</span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>


            <br>

            <div class="table__section table__section--head">
              Additional <span>Info</span>
            </div>

            <div class="card">
              <div class="card__content card__content--flex">
                <table width="100%">
                  <tr>
                    <td width="30%">
                      <span>USER REF (uref)</span><br>
                      {{ walletDetail.uref }}
                    </td>
                    <td width="30%">
                      <span>DATE CREATED</span><br>
                      {{ momentDate(walletDetail.createdAt) }}
                    </td>
                    <td width="30%">
                      <span>LAST ACTIVITY DATE</span><br>
                      {{ momentDate(walletDetail.updatedAt) }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>

        </div>
     </div>
    <div
      class="modal fade"
      id="createTransferModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="createTransferModal"
    >
    <div class="modal__dialog modal__dialog--xlg">
        <!-- Modal content -->
        <div class="modal__content">
          <div class="modal__header">
            <div class="modal__title">
              <span class="time-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  width="512px"
                  height="512px"
                  viewBox="0 0 612 612"
                  style="enable-background:new 0 0 612 612;"
                  xml:space="preserve"
                  class="icon--sm"
                >
                  <g>
                    <g>
                      <g>
                        <path
                          d="M587.572,186.881c-32.266-75.225-87.096-129.934-162.949-162.285C386.711,8.427,346.992,0.168,305.497,0.168    c-41.488,0-80.914,8.181-118.784,24.428C111.488,56.861,56.415,111.535,24.092,186.881C7.895,224.629,0,264.176,0,305.664    c0,41.496,7.895,81.371,24.092,119.127c32.323,75.346,87.403,130.348,162.621,162.621c37.877,16.247,77.295,24.42,118.784,24.42    c41.489,0,81.214-8.259,119.12-24.42c75.853-32.352,130.683-87.403,162.956-162.621C603.819,386.914,612,347.16,612,305.664    C612,264.176,603.826,224.757,587.572,186.881z M538.724,440.853c-24.021,41.195-56.929,73.876-98.375,98.039    c-41.195,24.021-86.332,36.135-134.845,36.135c-36.47,0-71.27-7.024-104.4-21.415c-33.129-14.384-61.733-33.294-85.661-57.215    c-23.928-23.928-42.973-52.811-57.214-85.997c-14.199-33.065-21.08-68.258-21.08-104.735c0-48.52,11.921-93.428,35.807-134.509    c23.971-41.231,56.886-73.947,98.039-98.04c41.146-24.092,85.99-36.142,134.502-36.142c48.52,0,93.649,12.121,134.845,36.142    c41.446,24.164,74.283,56.879,98.375,98.039c24.092,41.153,36.135,85.99,36.135,134.509    C574.852,354.185,562.888,399.399,538.724,440.853z"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#576ae6"
                          fill="#576ae6"
                        ></path>
                        <path
                          d="M324.906,302.988V129.659c0-10.372-9.037-18.738-19.41-18.738c-9.701,0-18.403,8.366-18.403,18.738v176.005    c0,0.336,0.671,1.678,0.671,2.678c-0.671,6.024,1.007,11.043,5.019,15.062l100.053,100.046c6.695,6.695,19.073,6.695,25.763,0    c7.694-7.695,7.188-18.86,0-26.099L324.906,302.988z"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#576ae6"
                          fill="#576ae6"
                        ></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
              Transfer to another Wallet
            </div>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="utilityMethods().closeTransfer()"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                <path
                  fill="#C0C6D8"
                  fill-rule="nonzero"
                  d="M8.254 6.5l4.383-4.382A1.24 1.24 0 0 0 10.882.363L6.5 4.746 2.118.363A1.24 1.24 0 1 0 .363 2.118L4.746 6.5.363 10.882a1.24 1.24 0 0 0 1.755 1.755L6.5 8.254l4.382 4.383a1.24 1.24 0 1 0 1.755-1.755L8.254 6.5z"
                ></path>
              </svg>
            </button>
          </div>
          <!-- Modal Body -->
          <div class="modal__body modal__body--pad">
            <div class>
              <form action
                    v-if="transferStarting1" class="form disburse-form disburse-form__single">
                <div class="form__item">
                  <label for="disburseAmount" class="form__label--span form--left">
                    Payment
                    <span>amount</span>
                  </label>
                  <div class="form--right input-conjoined">
                    <input
                      type="text"
                      class="form__input"
                      :disabled="true"
                      v-model="payoutObj.wallet.currency"
                      readonly
                    />
                    <input
                      type="number"
                      name="disburse-amount"
                      class="form__input"
                      placeholder
                      id="disburseAmount"
                      v-model="payoutObj.amount"
                      v-validate="'required|decimal:4'"
                    />
                  </div>
                </div>
                <!--if error exists-->
                <transition name="slide-fade">
                  <div class="form__input--error--text" v-if="errors.has('disburse-amount')">
                    <p>{{ errors.first('disburse-amount') }}</p>
                  </div>
                </transition>
                <!--payment beneficiary type-->
                <div class="form__item">
                  <label for="disburseSource" class="form__label--span form--left">
                    Send money
                    <span>to</span>
                  </label>
                  <div class="select recipient-list form--right">
                    <select
                      label="walletName"
                      name="disburse-source"
                      id="disburseSource"
                      class="select__input"
                      v-model="secondWalletDetail"
                      v-validate="'required'"
                      @change="selectedSecondarySource(secondWalletDetail)"
                    >
                      <option value disabled>Select wallet to disburse to</option>
                      <option v-for="option in filteredSecondary" v-bind:value="option" >
                        {{option.name.toUpperCase()}} - {{ option.shortCode }} {{option.balance | numeralize('0,0.00')}}
                      </option>
                    </select>
                  </div>
                </div>
                <transition name="slide-fade">
                  <div class="form__input--error--text" v-if="errors.has('disburse-source')">
                    <p>{{ errors.first('disburse-source') }}</p>
                  </div>
                </transition>
                <div class="panel__empty__text" v-if="message">
                  No wallet with the same currency.
                  <router-link :to="{name:'wallet-overview', params: { trigger: 'yes', currency: payoutObj.wallet.currency }}" class="link"> <span data-dismiss="modal"
                  aria-label="Close"> Create a Wallet </span></router-link>
                </div><br>
                <!--payment reference-->
                <div class="form__item">
                  <label for="disburseReference" class="form__label--span form--left">
                    Payment
                    <span>description</span>
                  </label>
                  <div class="amount-input form--right">
                    <input
                      type="text"
                      class="form__input"
                      id="disburseReference"
                      name="disburseReference"
                      placeholder="Paying my debts"
                      v-model="payoutObj.narration"
                    />
                  </div>
                </div>
                <div class="form__item">
                  <label for="walletPassword" class="form__label--span form--left">
                    Wallet
                    <span>password</span>
                  </label>
                  <div class="recipient-list form--right">
                    <input
                      id="walletPassword"
                      name="wpassword"
                      type="password"
                      autocomplete="new-password"
                      class="form__input"
                      placeholder
                      v-model="payoutObj.wallet.password"
                      v-validate="'required'"
                    />
                  </div>
                </div>
                <transition name="slide-fade">
                  <div class="form__input--error--text" v-if="errors.has('wpassword')">
                    <p>{{ errors.first('wpassword') }}</p>
                  </div>
                </transition>
                <div class="form__item disburse-form__submit xxschedule-payment" v-if="enableActions">
                  <a
                    class="btn btn--primary btn--block"
                    :disabled="errors.any()"
                    @click="verifyFields()"
                  >SEND NOW</a>
                </div>
              </form>
              <form
                class="disburse__confirmation"
                @submit.prevent="handleSecondaryDisbursement()"
                v-if="transferStarting"
              >
                <div class="disburse__confirmation__title text-center">
                  You are about to send
                  <span class>{{payoutObj.wallet.currency}}{{payoutObj.amount}}</span> to
                  <br />
                  <span>{{payoutObj.accountName}}</span> for
                  <br />
                  {{ payoutObj.narration }}
                </div>
                <div class="disburse__confirmation__breakdown">
                  <!--amount disbursed-->
                  <div class="breakdown__item">
                    <div class="breakdown__item__name">Payment amount</div>
                    <div
                      class="breakdown__item__result"
                    >{{payoutObj.wallet.currency}} {{payoutObj.amount}}</div>
                  </div>

                  <!--funding source-->
                  <div class="breakdown__item">
                    <div class="breakdown__item__name">Funding source</div>
                    <div
                      class="breakdown__item__result"
                    >{{payoutObj.source}} - {{payoutObj.wallet.currency}} balance</div>
                  </div>

                  <!--recipient-->
                  <!--account name resolved, beneficiary name-->
                  <div class="breakdown__item">
                    <div class="breakdown__item__name">Recipient</div>
                    <div class="breakdown__item__result">{{payoutObj.accountName}}</div>
                  </div>
                </div>

                <!--confirm disbursement-->
                <div class="disburse__confirmation__submit">
                  <button
                    class="btn btn--primary btn--block submit__paymentForm"
                    type="submit"
                  >CONFIRM PAYMENT</button>
                </div>
              </form>
              <div class="disburse__result text-center" v-if="disburseDone">
                <div v-if="disburseSuccessful">
                  <!--success icon-->
                  <div class="result-img">
                    <svg
                      class="icon icon--custom-big"
                      enable-background="new 0 0 50 50"
                      version="1.1"
                      viewBox="0 0 50 50"
                      xml:space="preserve"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="25" cy="25" r="25" fill="#25AE88"></circle>
                      <polyline
                        points="38 15 22 33 12 25"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></polyline>
                    </svg>
                  </div>
                  <p
                    class="disburse__result__success success-text"
                  >{{disburseDoneMsg}}</p>
                  <button
                    class="btn btn--primary"
                    @click="utilityMethods().newTransfer()"
                  >Make another transfer</button>
                  <button
                    class="btn btn--default"
                    @click="utilityMethods().triggerRefresh()"
                  >Check transfers status</button>
                </div>

                <div v-if="disburseFailed">
                  <div class="result-img">
                    <svg
                      enable-background="new 0 0 50 50"
                      version="1.1"
                      viewBox="0 0 50 50"
                      xml:space="preserve"
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon--custom-big"
                    >
                      <circle cx="25" cy="25" r="25" fill="#D75A4A"></circle>
                      <polyline
                        points="16 34 25 25 34 16"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></polyline>
                      <polyline
                        points="16 16 25 25 34 34"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></polyline>
                    </svg>
                  </div>
                  <p v-for="error in disburseErrors" class="disburse__result__error error-text">{{error}}</p>
                  <button
                    data-dismiss="modal"
                    aria-label="Close"
                    class="btn btn--primary"
                    @click="utilityMethods().retryTransfer()"
                  >Retry transfer</button>
                  <button
                    class="btn btn--default"
                    @click="utilityMethods().triggerRefresh()"
                  >See all transfers</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="createChangeModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="createChangeModal"
    >
      <!-- Modal Dialog -->
      <div class="modal__dialog modal__dialog--xsf" role="document">
        <!-- Modal content -->
        <div class="modal__content">
          <div id="snackbar"></div>
          <div id="negsnackbar"></div>
          <!-- Modal Body -->
          <div class="modal__body">
            <div class>
              <form action class="form form__padf" @submit.prevent="">
                <div class="form__item">
                  <input
                    type="text"
                    name="currentPassword"
                    placeholder="Current Password"
                    v-model="password"
                    id="currentPassword"
                    class="form__input input"
                    data-vv-id="1"
                    aria-required="true"
                    aria-invalid="false">
                </div>
                <div class="form__item">
                  <input
                    type="text"
                    name="newPassword56"
                    placeholder="New Password"
                    v-model="newPassword"
                    id="newPassword56"
                    class="form__input input"
                    data-vv-id="1"
                    aria-required="true"
                    aria-invalid="false">
                </div>
                <div class="form__item">
                  <input
                    type="text"
                    name="confirmPassword567"
                    placeholder="Confirm New Password"
                    v-model="confirmPassword"
                    id="confirmPassword567"
                    class="form__input input"
                    data-vv-id="1"
                    aria-required="true"
                    aria-invalid="false">
                </div>
                <br><br>

                <div class="form__item" style="text-align: center;">
                  <button style="min-width:45%;"
                    id="resetBtn"
                    type="submit"
                    class="btn btn--primary btn--block"
                    @click="change()"
                  >Change Password</button>
                </div>
                <div class="auth__login__forgot-pass text-center">
                  <span class="link" style="cursor: pointer;" @click="forgot()">
                    Forgot password
                  </span>
                  <!-- <router-link :to="{name: 'forgot-password'}" class="link">Forgot <span>your password?</span>
                  </router-link> -->
                </div>
                <br>
              </form>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import {getTranferDetails, sendReceipts, retryPayout} from '../../utils/wallet-transactions/transferService';
  import {getWallets, walletTransfer } from "../../utils/wallet-transactions/walletService";
  import ModalTemplate from "@/components/partials/ModalTemplate.vue";
  import vSelect from "vue-select";
  import {forgotWalletPassword, changeWalletPassword, getWalletById} from '../../utils/wallet-transactions/walletService';
  import moment from 'moment';

  export default {

    created(){
      this.handleWalletDetail();  // Fetches transfers when the component is created.
      this.handleSecondaryWallet();
    },


    mounted(){
    },


    beforeRouteUpdate (to, from, next) {
      this.$Progress.start();
      this.handleWalletDetail();
      this.$Progress.finish();
      // don't forget to call next()
      next()
    },


    data() {
      return {
        isLoading: true,
        walletDetail: {},
        type: '',

        // transfer to wallet data
        selectedBalance: "",
        secondWalletDetail: "",
        selectedBalance: {},
        SecondaryBalance: {},
        payoutObj: {
          source: "wallet",
          type: "single",
          sender: window.localStorage.getItem("merchantName"),
          amount: "",
          wallet: {
            password: "",
            currency: ""
          },
          narration: "",
          wallet_id: "",
          destUref: "",
          accountName: "",
          sourceUref: "",
        },
        disburseDoneMsg: "",
        secondWalletList: [],
        disburseDone: false,
        disburseSuccessful: false,
        disburseFailed: false,
        disburseErrors: [],
        banksList: [],
        banksListObj: {},
        filteredBankList: [],
        filteredSecondary: [],
        fullWalletList: [],
        message: false,
        toTransfer: false,
        transferStarting: false,
        transferStarting1: true,

        //change Wallet Password
        // changePassword: false,
        password: '',
        newPassword: '',
        confirmPassword: '',
        passwordErrors: [],
        errorExists: false,
        email: '',

        //Disable Wallet
        disableWallet: false,
      }
    },
    props:{
      name,
    },
    components:{
      "modal-template": ModalTemplate,
      "v-select": vSelect,
    },
    watch: {
      // call again the fetch method if the route changes
      '$route': 'handleWalletDetail'
    },

    computed:{
      enableActions: {
        get() {
          return this.$store.state.enableActions;
        },
      },
      walletList() {
        let a = JSON.parse(window.localStorage.getItem("walletList"));
        let index = {};
        let contains = false;
        if (Object.keys(this.SecondaryBalance).length > 0) {
          Object.keys(a).forEach(response => {
            index[a[response].currencyId] = response;
            if (a[response].currencyId === this.SecondaryBalance.id) {
              contains = true;
            }
          });
          if (contains == false) {
            a[
              Object.keys(
                JSON.parse(window.localStorage.getItem("walletList"))
              ).length
            ] = {
              country: this.SecondaryBalance.currency.countryTag,
              currencyBalance: this.SecondaryBalance.balance,
              currencyCode: this.SecondaryBalance.currency.shortCode,
              currencyId: this.SecondaryBalance.id,
              currencyUref: this.SecondaryBalance.uref
            };
            this.selectedBalance =
              a[
                Object.keys(
                  JSON.parse(window.localStorage.getItem("walletList"))
                ).length
              ];
            this.selectedSource(this.selectedBalance);
          } else {
            this.selectedBalance = a[index[this.$route.params.id]];
            this.selectedSource(a[index[this.$route.params.id]]);
          }
        }
        if (this.secondWalletList.length > 0) {
          Object.values(this.secondWalletList).forEach((res) => {
            let ab = {
              country: res.country,
              countryName: res.countryName,
              currencyBalance: res.balance,
              currencyCode: res.shortCode,
              currencyId: res.id,
              currencyUref: res.uref,
              name: res.name,
            }
            a.push(ab)
          })
        }
        return a;
      },
    },

    methods:{
        momentDate(date) {
            return moment(date).format('MMM Do, YYYY . HH:mm:ss')
        },
      optionType(){
        if(this.type === 'Transfer'){
          // $("#createTransferModal").modal();
          $('#createTransferModal').modal('show');
          // this.toTransfer = true;
        }
        else if (this.type === 'Password'){
          $('#createChangeModal').modal('show');
          // this.changePassword = true;
        }
        // else if (this.type === 'Disable'){
        //   this.disableWallet = true;
        //   // this.DisWallet();
        // }
      },

      // transfer to wallet
      getWallet() {
        let a = JSON.parse(window.localStorage.getItem("walletList"));
        if (this.secondWalletList.length > 0) {
          Object.values(this.secondWalletList).forEach((res) => {
            let ab = {
              country: res.country,
              countryName: res.countryName,
              currencyBalance: res.balance,
              currencyCode: res.shortCode,
              currencyId: res.id,
              currencyUref: res.uref,
              name: res.name,
            }
            a.push(ab)
          })
        }
        this.fullWalletList = a;
        Object.values(a).forEach((respo) => {
          if (Number(respo.currencyId) === Number(this.$route.params.id)) {
            this.selectedBalance = respo;
            this.selectedSource(respo);
          }
        });
      },

      selectedSource(wallet) {
        let newList = [];
        Object.values(this.fullWalletList).forEach((r) => {
          if (r.currencyId != this.selectedBalance.currencyId) {
            let ab = {
              balance: r.currencyBalance,
              country: r.country,
              countryName: r.countryName,
              currencyId: '',
              id: r.currencyId,
              name: r.name,
              shortCode: r.currencyCode,
              uref: r.currencyUref,
            };
            newList.push(ab);
          } else {}
        });
        this.payoutObj.sourceUref = wallet.currencyUref;
        this.payoutObj.wallet.currency = wallet.currencyCode;
        this.filteredBankList = [];
        this.filteredSecondary = newList.filter(benf => {
          if (benf.shortCode === wallet.currencyCode) {
            return true;
          }
        });
        if (this.filteredSecondary.length === 0) this.message = true;
      },

      selectedSecondarySource(source) {
        this.payoutObj.accountName = source.name;
        this.payoutObj.wallet_id = source.id;
        this.payoutObj.destUref = source.uref;
      },

      verifyFields() {
        //validate all fields
        this.$validator.validateAll().then(result => {
          if (result) {
            this.transferStarting = true;
            this.transferStarting1 = false;
            //trigger modal
            $("#confirmPaymentModal").modal("show");
          }
        });
      },

      handleSecondaryWallet() {
        getWallets(10, 1, "secondary")
          .then(resp => {
            this.secondWalletList.length = 0;
            resp.data.data.forEach(b => {
              this.secondWalletList.push({
                balance: b.balance,
                country: b.currency.countryTag,
                countryName: b.currency.countryName,
                name: b.name,
                uref: b.uref,
                id: b.id,
                currencyId: b.currency.id,
                shortCode: b.currency.shortCode
              });
            });
            this.getWallet();
          })
          .catch(error => {});

      },

      handleSecondaryDisbursement() {
        this.$Progress.start();
        let submitBtn = document.getElementsByClassName("submit__paymentForm");
        submitBtn.disabled = true;
        submitBtn.innerHTML = "Processing...";
        this.payoutObj.reference = `fe${Math.random()
          .toString()
          .slice(2, 10)}.${Math.random()
          .toString()
          .slice(2, 10)}`;
        walletTransfer(this.payoutObj)
          .then(resp => {
              this.disburseDone = true;
              this.transferStarting1 = false;
              this.transferStarting = false;
              if (resp.data.data === 'Transfer Successful') {
                this.disburseSuccessful = true;
                this.disburseFailed = false;
                this.disburseDoneMsg =  resp.data.data;
              } else {
                this.disburseDoneMsg = 'Transfer Failed';
                this.disburseSuccessful = false;
                this.disburseFailed = true;
              }
            this.$Progress.finish();
          })
          .catch(error => {
            this.$Progress.fail();
            console.log(error);
            this.disburseDone = true;
            this.transferStarting1 = false;
            this.transferStarting = false;
            this.disburseFailed = true;
            this.disburseSuccessful = false;
            if (error.response) this.disburseErrors.push(error.response.data.message);
            else this.disburseErrors.push('Trasnfer Failed');
          });
      },

      //change wallet Password
      change() {
        document.getElementById("resetBtn").disabled = true;
        this.errorExists = false;
        this.email = this.$cookies.get('userEmail');
        if (this.email !== "" && this.password !== "" && this.confirmPassword !== "" ) {
          this.$Progress.start();
          if (this.newPassword === this.confirmPassword) {
            let data = {};
            data.email = this.email;
            data.id = this.$route.params.id;
            data.lockCode = this.password
            data.newLockCode = this.newPassword;
            changeWalletPassword(data)
            .then((response) => {
              if (response.data.data.status === "completed") {
                this.$Progress.finish();
                this.showSnackbar(
                  "You have successfully changed your password"
                );
              } else {
                this.$Progress.fail();
                this.errorExists = true;
                this.showSnackbar("There was an error changing your password, please try again");
                document.getElementById("resetBtn").disabled = false;
              }
            })
            .catch((error) => {
              document.getElementById("resetBtn").disabled = false;
              this.errorExists = true;
              this.$Progress.fail();
              this.showSnackbar(error.response.data.message.msg || 'There was an error changing your password, please try again');
              console.log(error.response.data.message);
            })
          } else {
            this.errorExists = true;
            this.$Progress.fail();
            this.showSnackbar("Your password has to match");
            document.getElementById("resetBtn").disabled = false;
          }
        } else {
          this.errorExists = true;
          this.$Progress.fail();
          document.getElementById("resetBtn").disabled = false;
          this.showSnackbar("Please fill all fields");
        }
      },

      forgot() {
        let data = {};
        data.email = this.$cookies.get('userEmail');
        data.id = this.$route.params.id;
        this.errorExists = false;
        this.$Progress.start();
        forgotWalletPassword(data)
        .then((response) => {
          if (response.data.data.notified) {
            this.$Progress.finish();
            if (JSON.parse(response.data.data.notified.m).data.code === "00") {
              this.showSnackbar("A reset password has been sent to your email");
            } else if (JSON.parse(response.data.data.notified.m).data.code !== "00") {
              this.errorExists = true;
              this.$Progress.fail();
              this.showSnackbar("There was an error sending the password, please try again");
            }
          } else {
            this.$Progress.finish();
            this.errorExists = true;
            this.$Progress.fail();
            this.showSnackbar("There was an error sending the password, please try again");
          }
        })
        .catch((error) => {
          this.errorExists = true;
          this.$Progress.fail();
          this.showSnackbar("There was an error sending the link, please try again");
          console.log(error.response.data.message);
        })
      },

      showSnackbar(text) {
        let snackbar = document.getElementById("snackbar");
        if (this.errorExists) snackbar = document.getElementById("negsnackbar");
        snackbar.innerHTML = text;
        snackbar.className = "show";

        setTimeout(function() {
          snackbar.className = snackbar.className.replace("show", "");
        }, 10000);
      },

      handleWalletDetail(){
        this.$Progress.start();
        getWalletById(this.$route.params.id).then((resp) => {
          if (resp.data.data) {
            this.$Progress.finish();
            this.walletDetail = resp.data.data;
            this.isLoading = false;
          }
          else this.$Progress.failed();
        })
        .catch((error) => {
          this.$Progress.failed();
          console.log(error);
        })
        // getTranferDetails(this.$route.params.id).then((resp) => {
        //   if(resp.status === 200 && resp.data.data && resp.data.data.count === 1){
        //     this.isLoading = false;
        //     this.$Progress.finish()
        //     this.transfer = resp.data.data.response[0];
        //     this.contains = this.transfer.ref.includes('_RETRY_');
        //   } else {

        //   }
        // }).catch((err) => {
        //   console.log(err);
        // });
      },

      utilityMethods() {
        let self = this;
        return {
          passwordClose(){
            // self.changePassword = false,
            self.password = '',
            self.newPassword = '',
            self.confirmPassword = '',
            self.passwordErrors = [],
            self.errorExists = false,
            self.email = '',
            self.type = '';
          },
          retryTransfer(){
            self.disburseDoneMsg = "";
            self.disburseDone = false;
            self.disburseSuccessful = false;
            self.disburseFailed = false;
            self.disburseErrors = [];
            self.transferStarting1 = true;
            self.transferStarting = false;
          },
          closeTransfer(){
            self.disburseDoneMsg = "";
            self.disburseDone = false;
            self.disburseSuccessful = false;
            self.disburseFailed = false;
            self.disburseErrors = [];
            self.transferStarting1 = true;
            self.transferStarting = false;
            // self.toTransfer = false;
            // self.message = false;
            self.type = '';
            self.secondWalletDetail = "";
            self.payoutObj.amount = "";
            self.payoutObj.narration = "";
            self.payoutObj.wallet.password = "";
            self.handleWalletDetail();
          },
          newTransfer(){
            self.disburseDoneMsg = "";
            self.disburseDone = false;
            self.disburseSuccessful = false;
            self.disburseFailed = false;
            self.disburseErrors = [];
            self.transferStarting1 = true;
            self.transferStarting = false;
            // self.toTransfer = true;
            // self.message = false;
            self.secondWalletDetail = "";
            self.payoutObj.amount = "";
            self.payoutObj.narration = "";
            self.payoutObj.wallet.password = "";
            self.handleSecondaryWallet();
            self.handleWalletDetail();
          },
          //page load methods
          triggerRefresh() {
            self.$router.push("/transfers/all");
            location.reload();
          },
        };
      },
    },

  }
</script>

<style scoped>
#snackbar {
  visibility: hidden;
  /*poisition: fixed;*/
  top: 0px;
  background-color: deepskyblue;
  color: white;
  padding: 5px;
  text-align: center;
}

#negsnackbar {
  visibility: hidden;
  /*poisition: fixed;*/
  top: 0px;
  background-color: red;
  color: white;
  padding: 5px;
  text-align: center;
}

#snackbar.show {
  visibility: visible;
}

#negsnackbar.show {
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/wallet/SingleBalanceDetails.vue